<div class="card card-custom gutter-b card-fit" data-card="true" id="kt_card_1">
    <div class="card-header">
        <div class="card-title">

        </div>
        <div class="card-toolbar">
            <button type="button" class="btn btn-secondary btn-sm  font-weight-bold" (click)="filter()">
                <i class="fas fa-filter icon-sm"></i>Filter
            </button>
        </div>
    </div>
    <div class="card-body  mt-0 py-0 px-5">
        <div class="row">
            <div class="col-lg-5 col-sm-12 separator-vertical ">
                <h6 class="mb-5">Allow Change</h6>
                <div class="row">
                    <div class="col-lg-12">
                        <div class="checkbox-inline">
                            <label class="checkbox checkbox-lg mr-10">
                                <input type="checkbox" name="_allow_balance" autocomplete="off"
                                    [(ngModel)]="clientService.client.allow_balance" (change)="save()">
                                <span></span>
                                Allow Balance
                            </label>

                            <label class="checkbox checkbox-lg">
                                <input type="checkbox" class="form-control " name="_allow_check" autocomplete="off"
                                    [(ngModel)]="clientService.client.allow_check" (change)="save()">
                                <span></span>
                                Checks Not Allowed
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-7 col-sm-12">

                <h6 class="mb-2">Account Activity</h6>
                <div class="row">
                    <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                            <label>Opened:</label>
                            <input type="text" class="form-control " name="_date_added" autocomplete="off" readonly
                                [(ngModel)]="clientService.client.date_added">
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                            <label>Last Activity:</label>
                            <input type="text" class="form-control " name="_last_visit" autocomplete="off" readonly
                                [(ngModel)]="clientService.client.last_visit">
                        </div>
                    </div>

                    <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                            <label>Last Pay Date:</label>
                            <input type="text" class="form-control " name="_max_cashreg_date" autocomplete="off"
                                readonly [(ngModel)]="clientService.client.max_cashreg_date">
                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-lg-12 my-3 separator separator-dashed"></div>
        <form class="row">
            <div class="col-lg-5 col-sm-12 mb-4 ">
                <h6 class="pt-4">Client Financial</h6>
            </div>
            <div class="col-lg-7 col-sm-12 ">
                <div class="row">
                    <div class="col-md-4 col-sm-12 mb-4">
                        <input type="date" class="form-control" name="start_date" placeholder="Start Date"
                            [(ngModel)]="start_date" (change)="dateOnChange()">
                    </div>
                    <div class="col-md-4 col-sm-12 mb-4">
                        <input type="date" class="form-control" name="end_date" placeholder="End Date"
                            [(ngModel)]="end_date" (change)="dateOnChange()">
                    </div>
                    <div class="col-md-4 col-sm-12 mb-4">
                        <button type="button" class="btn btn-info  font-weight-bold" (click)="print()"><i
                                class="las la-print"></i> Print Report</button>
                    </div>
                </div>
            </div>
        </form>
        <div class="table-responsive">
            <table class="table table-sm table-bordered">
                <thead class="thead-light">
                    <tr>
                        <th></th>
                        <th>Date</th>
                        <th>Invoice No</th>
                        <th>Pet Name</th>
                        <th>Charge + Tax</th>
                        <th><span class="c_blue">Deposit</span>/<span class="c_red">Balance</span></th>
                        <th>Discount</th>
                        <th>Total Charge</th>
                        <th> Amount Paid</th>
                        <th>FID</th>
                        <th>Total <span class="c_blue">Deposit</span>/<span class="c_red">Balance</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of invoiceService.clientfinance_cr">
                        <td>
                            <button type="button" class="btn btn-secondary btn-xs mr-2"
                                (click)="printinvoice(item.invoice_no,item.pet_no)"
                                title="View Invoice Receipt">
                                <i class="las la-receipt"></i>
                            </button>
                            <button type="button" class="btn btn-secondary btn-xs"
                                (click)="original_receipt(item.file_id)"
                                title="Print Original Receipt">
                                <i class="las la-print"></i>
                            </button> 
                        </td>
                        <td>
                            {{ item.inv_date }}
                        </td>
                        <td>
                            {{ item.invoice_no }}
                        </td>
                        <td>
                            {{ item.pet_name }}
                        </td>
                        <td>
                            {{ (item.total_charge + item.total_tax) | currency }}
                        </td>
                        <td>
                            <span [ngClass]="{'c_blue': item.deposit !== 0, 'c_red': item.deposit === 0}">
                                {{ (item.deposit !== 0 ? item.deposit : item.prior_balance) | currency }}
                            </span>
                        </td>
                        <td>
                            {{ item.Discount | currency}}
                        </td>
                        <td>
                            {{ item.balance_due | currency}}
                        </td>
                        <td>
                            {{ item.amount_paid | currency}}
                        </td>
                        <td>
                            {{ item.file_id }}
                        </td>
                        <td>
                            <span [ngClass]="{'c_blue': item.current_balance < 0, 'c_red': item.current_balance >  0}">
                                {{ item.current_balance | currency}}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- <nav aria-label="Page navigation example">
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" [ngClass]="page === page_number_payment_record ? 'active': ''"
                                        *ngFor="let page of clientService.pages_client_cash_reg"
                                        (click)="view_page_cash_reg(page)">
                                        <a class="page-link">
                                            {{ page }}
                                        </a>
                                    </li>
                                </ul>
                            </nav> -->

        <div class="row">
            <div class="col">
                <div class="form-group">
                    <label>Previous Balance:</label>
                    <input type="text" class="form-control " name="_balance" required autocomplete="off" readonly
                        [value]="clientService.client.balance | currency">
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label>Amount Past Due 30 Days:</label>
                    <input type="text" class="form-control " name="_appointment_date" required autocomplete="off"
                        readonly [value]="0 | currency">
                </div>
            </div>


            <div class="col">
                <div class="form-group">
                    <label>Amount Past Due 60 Days:</label>
                    <input type="text" class="form-control " name="_appointment_date" required autocomplete="off"
                        readonly [value]="0 | currency">
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label>Amount Past Due 90+ Days:</label>
                    <input type="text" class="form-control " name="_appointment_date" required autocomplete="off"
                        readonly [value]="0 | currency">
                </div>
            </div>
        </div>


        <!-- <div class="card">
                <div class="card-header" id="headingThree">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                            data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            Hold Checks
                        </button>
                    </h2>
                </div>
                <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
                    <div class="card-body">

                        <span *ngIf="clientService.client_hold_check.length === 0">No information available</span>
                        <div class="table-responsive" style="height: 25vh;" *ngIf="clientService.client_hold_check.length > 0">
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th>
                                            Invoice Date
                                        </th>
                                        <th>
                                            Amount Paid
                                        </th>
                                        <th>
                                            Payment Type
                                        </th>
                                        <th>
                                            Check #/Reasons
                                        </th>
                                        <th>
                                            Cashier
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let item of catalogService.paginate(clientService.client_hold_check, page_number_hold_checks)">
                                        <td>
                                            {{ item.cashreg_date }}
                                        </td>
                                        <td>
                                            {{ item.amount_of_pay | currency }}
                                        </td>
                                        <td>
                                            {{ item.payment_desc }}
                                        </td>
                                        <td>
                                            {{ item.check_card }}
                                        </td>
                                        <td>
                                            {{ item.cashier }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div> -->
        <!-- <div class="card">
                <div class="card-header" id="headingFour">
                    <h2 class="mb-0">
                        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse"
                            data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                            Return Checks Record
                        </button>
                    </h2>
                </div>
                <div id="collapseFour" class="collapse" aria-labelledby="headingFour" data-parent="#accordionExample">
                    <div class="card-body">

                        <span *ngIf="clientService.client_ret_check.length === 0">No information available</span>
                        <div class="table-responsive" style="height: 25vh;" *ngIf="clientService.client_ret_check.length > 0">
                            <table class="table table-sm table-striped">
                                <thead>
                                    <tr>
                                        <th>
                                            Invoice Date
                                        </th>
                                        <th>
                                            Amount Paid
                                        </th>
                                        <th>
                                            Payment Type
                                        </th>
                                        <th>
                                            Check #/Reasons
                                        </th>
                                        <th>
                                            Cashier
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngFor="let item of catalogService.paginate(clientService.client_ret_check, page_number_ret_checks)">
                                        <td>
                                            {{ item.cashreg_date }}
                                        </td>
                                        <td>
                                            {{ item.amount_of_pay | currency }}
                                        </td>
                                        <td>
                                            {{ item.payment_desc }}
                                        </td>
                                        <td>
                                            {{ item.check_card }}
                                        </td>
                                        <td>
                                            {{ item.cashier }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation example">
                                <ul class="pagination flex-wrap">
                                    <li class="page-item" [ngClass]="page === page_number_ret_checks ? 'active': ''"
                                        *ngFor="let page of clientService.pages_client_ret_check"
                                        (click)="view_page_return_checks(page)">
                                        <a class="page-link">
                                            {{ page }}
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                    </div>
                </div>
            </div> -->


        <!-- <div class="card card-custom gutter-b card-strech">
            <div class="card-header card-header-tabs-line">
                <div class="card-toolbar">
                    <ul class="nav nav-tabs nav-bold nav-tabs-line">
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="{ 'active': payment_record }" data-toggle="tab"
                                href="#pills-payment-record" (click)="ver('payment_record')">
                                <span class="nav-text">
                                    Payment Record
                                </span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="{ 'active': balance_record }" id="pills-balance-record-tab"
                                data-toggle="tab" data-bs-target="#pills-balance-record" href="#pills-balance-record"
                                (click)="ver('balance_record')">
                                Balance Record
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="{ 'active': hold_checks }" id="pills-hold-checks-tab"
                                data-toggle="tab" data-bs-target="#pills-hold-checks" href="#pills-hold-checks"
                                (click)="ver('hold_checks')">
                                Hold Checks
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="{ 'active': return_checks }" id="pills-return-checks"
                                data-toggle="tab" data-bs-target="#pills-return-checks" href="#pills-return-checks"
                                (click)="ver('return_checks')">
                                Return Checks Record
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tab-content">
                <div class="tab-pane fade" [ngClass]="{ 'show active': payment_record }" id="pills-payment-record"
                    role="tabpanel" aria-labelledby="pills-payment-record-tab">
                </div>
                <div class="tab-pane fade" [ngClass]="{ 'show active': balance_record }" id="pills-balance-record"
                    role="tabpanel" aria-labelledby="pills-balance-record-tab">
                </div>
                <div class="tab-pane fade" [ngClass]="{ 'show active': hold_checks }" id="pills-hold-checks"
                    role="tabpanel" aria-labelledby="pills-hold-checks-tab">
                </div>
                <div class="tab-pane fade" [ngClass]="{ 'show active': return_checks }" id="pills-return-checks"
                    role="tabpanel" aria-labelledby="pills-return-checks">
                </div>
            </div>
        </div> -->



    </div>
</div>


<div class="modal fade" id="modalFilterFinancial" tabindex="-1" role="dialog"
    aria-labelledby="modalFilterFinancialLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
            <form (ngSubmit)="apply()" #formFilter="ngForm">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalNewPetNoteLabel">Filter</h5>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                        <i aria-hidden="true" class="ki ki-close"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col form-group">
                            <label>
                                From:
                            </label>
                            <input type="date" class="form-control" name="_from" autocomplete="false"
                                [(ngModel)]="from" />
                        </div>
                        <div class="col form-group">
                            <label>
                                To:
                            </label>
                            <input type="date" class="form-control" name="_to" autocomplete="false" [(ngModel)]="to" />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col form-group">
                            <label>
                                Payment Type:
                            </label>
                            <select class="form-control " name="_payment" id="_payment" [(ngModel)]="payment">
                                <option value=""></option>
                                <option [value]="item" *ngFor="let item of payments">
                                    {{ item }}
                                </option>
                            </select>
                        </div>
                        <div class="col form-group">
                            <label>
                                Check #/Reasons:
                            </label>
                            <select class="form-control " name="_reason" id="_reason" [(ngModel)]="reason">
                                <option value=""></option>
                                <option [value]="item" *ngFor="let item of reasons">
                                    {{ item }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col form-group">
                            <label>
                                Cashier:
                            </label>
                            <select class="form-control " name="_cashier" id="_cashier" [(ngModel)]="cashier">
                                <option value=""></option>
                                <option [value]="item" *ngFor="let item of cashiers">
                                    {{ item }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <!-- -->
                    <button type="submit" class="btn font-weight-bold btn-primary" [disabled]="formFilter.invalid">
                        Apply
                    </button>
                    <button type="button" class="btn font-weight-bold btn-secondary ml-3" data-bs-dismiss="modal"
                        aria-label="Close" (click)="clear()">
                        Clear
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>



<style>
    .c_blue {
        color: blue
    }

    .c_red {
        color: red
    }
</style>